import GradeLessonPage from '../components/GradeLessonPage';
import { grade11Data } from './data';

export default function Grade11Page() {
  return (
    <GradeLessonPage
      grade="Grade 11"
      gradeLabel="Grade 11"
      gradeColor="rose"
      topics={grade11Data}
      prevGrade={{ label: 'Grade 10', path: '/grade/10' }}
      nextGrade={{ label: 'Pre-Calculus', path: '/precalc' }}
    />
  );
}
